module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1053-584a187ec410b8e78387659165672d3b.png";